/**
 * AB#2060 — the owner Payments "Total Revenue" summary must reconcile with the
 * CAPTURED (collected) pay-at-salon transactions the page shows. Failed / Pending
 * rows are displayed but are NOT collected revenue, so they are excluded.
 *
 * Pure helper (no new calculation — the same filter+reduce the page used inline)
 * extracted so it can carry regression coverage.
 */
export interface RevenueRow {
    amount: number;
    status?: string;
}

export function sumCapturedRevenue(transactions: readonly RevenueRow[]): number {
    if (!Array.isArray(transactions)) return 0;
    return transactions
        .filter((t) => (t.status || '').toLowerCase() === 'captured')
        .reduce((sum, t) => sum + (Number(t.amount) || 0), 0);
}
